import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { route } from "./routes";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CompletedOrder from "./components/MyBooking/CompletedOrder";
import { Provider, useDispatch } from "react-redux";
import { store } from "./redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect, React, Fragment, useState } from "react";
import { getAllCars } from "./redux/Slice/carSlice";
import useVisibilityChange from "./useVisibilityChange"
import { setupNotifications } from './firebase';
import { toastNotification, sendNativeNotification } from './notificationHelpers';
  // import useVisibilityChange from "./useVisibilityChange"
  // import useVisibilityChange from "./useVisibilityChange"
function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const shouldRenderNavbarFooter = !location.pathname.includes("app-payment");
  useEffect(() => {
    dispatch(getAllCars());
  }, []);
  const [isLoading, setIsLoading] = useState(true);

  const handleLoading = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    window.addEventListener("load", handleLoading);
    return () => window.removeEventListener("load", handleLoading);
  }, []);

  const isForeground = useVisibilityChange();
  useEffect(() => {
    setupNotifications((message) => {
      console.log("message",message)
       const { title, body } = message.notification; 
      if (isForeground) {
        // App is in the foreground, show toast notification
        toastNotification({
          // title:"title",
          // description: "body",
          // status: "info",
          title,
          description: body,
          status: "info",
        });
      } else {
        // App is in the background, show native notification
        sendNativeNotification({
          // title:'title',
          // body:"body",
          title,
          body,
        });
      }
    });
  }, []);
  return (
    // <Provider store={store} >

    <>
     {shouldRenderNavbarFooter && <Navbar />}
          <GoogleOAuthProvider>
            <Routes>
              {route.map((route, index) => {
                return (
                  <Fragment key={route.id}>
                    <Route
                      key={route.id}
                      path={route.path}
                      element={route.component}
                    >
                      {route.subroute
                        ? route.subroute.map((subroute, index) => {
                            return (
                              <Fragment key={index}>
                                <Route
                                  key={index}
                                  index
                                  element={<CompletedOrder />}
                                />
                                <Route
                                  key={subroute.id}
                                  path={subroute.path}
                                  element={subroute.component}
                                />
                              </Fragment>
                            );
                          })
                        : null}
                    </Route>
                  </Fragment>
                );
              })}
            </Routes>
          </GoogleOAuthProvider>
          {/* <Footer /> */}
          {shouldRenderNavbarFooter && <Footer />}
          <ToastContainer
            autoClose={2000}
            hideProgressBar={true}
            closeOnClick
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover={false}
            theme="light"
          />
    
      {/* <Navbar /> */}
    </>
    // </Provider>
  );
}

export default App;


// loader added code 

// { isLoading ? (
//   <>
//     {/* <div className="loader-overlay">
//       <div className="loader-container">
//         <p>Please wait...</p>
//         <div className="loader-dots-circle">
//           <span></span>
//           <span></span>
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       </div>
//     </div> */}
//      <div className="loader-overlay">
//     <div className="loader-container">
//   <div className="ml-loader">
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//     <div></div>
//   </div>
// </div>
// </div>
//   </>
// ) : (
//   <>
//     {shouldRenderNavbarFooter && <Navbar />}
//     <GoogleOAuthProvider>
//       <Routes>
//         {route.map((route, index) => {
//           return (
//             <Fragment key={route.id}>
//               <Route
//                 key={route.id}
//                 path={route.path}
//                 element={route.component}
//               >
//                 {route.subroute
//                   ? route.subroute.map((subroute, index) => {
//                       return (
//                         <Fragment key={index}>
//                           <Route
//                             key={index}
//                             index
//                             element={<CompletedOrder />}
//                           />
//                           <Route
//                             key={subroute.id}
//                             path={subroute.path}
//                             element={subroute.component}
//                           />
//                         </Fragment>
//                       );
//                     })
//                   : null}
//               </Route>
//             </Fragment>
//           );
//         })}
//       </Routes>
//     </GoogleOAuthProvider>
//     {/* <Footer /> */}
//     {shouldRenderNavbarFooter && <Footer />}
//     <ToastContainer
//       autoClose={2000}
//       hideProgressBar={true}
//       closeOnClick
//       pauseOnFocusLoss={false}
//       draggable
//       pauseOnHover={false}
//       theme="light"
//     />
//   </>
// )}